import type { FC } from 'react';
import { useCallback } from 'react';
import { useDeposit } from '@mwl/core-lib';
import { PaymentFormHeader } from '../../../../components/PaymentFormHeader/PaymentFormHeader';
import styles from './DepositFormIframeScript.module.scss';
export const DepositFormIframeScript: FC = () => {
  const {
    content: {
      iframeScript
    },
    changePayment,
    changeContent
  } = useDeposit();
  const handleClose = useCallback(() => {
    changeContent({
      form: 'create',
      iframeScript: undefined
    });
    changePayment();
  }, [changeContent, changePayment]);
  return <div className={styles.root} data-sentry-component="DepositFormIframeScript" data-sentry-source-file="DepositFormIframeScript.tsx">
      <PaymentFormHeader onClose={handleClose} data-sentry-element="PaymentFormHeader" data-sentry-source-file="DepositFormIframeScript.tsx" />
      <div className={styles.frameWrapper}>
        <iframe srcDoc={iframeScript} title={iframeScript} />
      </div>
    </div>;
};